import axios from 'axios'

axios.defaults.timeout = 10000

axios.defaults.baseURL = process.env.VUE_APP_BASE_API

axios.interceptors.request.use(
  config => {
    // const token = localStorage.token
    // if (token && token !== '') {
    //   config.headers.Authorization = 'JWT ' + token
    //   config.headers['X-Access-Token'] = 'JWT ' + token
    // }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error.response)
  }
)
export default axios
